import "core-js/modules/es.object.to-string";
import _classCallCheck from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/createClass";
import _getPrototypeOf from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/get";
import _createSuper from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/iframe/iframeview
 */
import View from '../view';
/**
 * The iframe view class.
 *
 * 		const iframe = new IframeView();
 *
 *		iframe.render();
 *		document.body.appendChild( iframe.element );
 *
 * 		iframe.on( 'loaded', () => {
 *			console.log( 'The iframe has loaded', iframe.element.contentWindow );
 *		} );
 *
 * 		iframe.element.src = 'https://ckeditor.com';
 *
 * @extends module:ui/view~View
 */

var IframeView = /*#__PURE__*/function (_View) {
  _inherits(IframeView, _View);

  var _super = _createSuper(IframeView);

  /**
   * Creates a new instance of the iframe view.
   *
   * @param {module:utils/locale~Locale} [locale] The locale instance.
   */
  function IframeView(locale) {
    var _this;

    _classCallCheck(this, IframeView);

    _this = _super.call(this, locale);
    var bind = _this.bindTemplate;

    _this.setTemplate({
      tag: 'iframe',
      attributes: {
        class: ['ck', 'ck-reset_all'],
        // It seems that we need to allow scripts in order to be able to listen to events.
        // TODO: Research that. Perhaps the src must be set?
        sandbox: 'allow-same-origin allow-scripts'
      },
      on: {
        load: bind.to('loaded')
      }
    });

    return _this;
  }
  /**
   * Renders the iframe's {@link #element} and returns a `Promise` for asynchronous
   * child `contentDocument` loading process.
   *
   * @returns {Promise} A promise which resolves once the iframe `contentDocument` has
   * been {@link #event:loaded}.
   */


  _createClass(IframeView, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return new Promise(function (resolve) {
        _this2.on('loaded', resolve);

        _get(_getPrototypeOf(IframeView.prototype), "render", _this2).call(_this2);
      });
    }
  }]);

  return IframeView;
}(View);
/**
 * Fired when the DOM iframe's `contentDocument` finished loading.
 *
 * @event loaded
 */


export { IframeView as default };